import {AlertIcon, type Icon} from '@primer/octicons-react'
import {Octicon} from '@primer/react/deprecated'
import type {PropsWithChildren, ReactNode} from 'react'

import {Blankslate} from '../common/blankslate'
import styles from './blankslate-error-message.module.css'

interface BlankslateErrorMessageProps {
  icon?: Icon
  heading: ReactNode
  content: ReactNode
  as?: React.ElementType
  headingAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
}

export const BlankslateErrorMessage: React.FC<PropsWithChildren<BlankslateErrorMessageProps>> = ({
  icon = AlertIcon,
  heading,
  content,
  children,
  headingAs: Heading = 'h2',
  ...props
}) => (
  <Blankslate {...props}>
    <Octicon icon={icon} size={30} className={styles.Octicon} />
    <Heading className={styles.Text}>{heading}</Heading>
    <p className={styles.Octicon}>{content}</p>
    {children}
  </Blankslate>
)
